import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[appPreventBlurPropagation]',
  exportAs: 'appPreventBlurPropagation',
})
export class PreventBlurPropagationDirective implements OnInit, OnDestroy {
  private readonly el = inject(ElementRef);

  private readonly focusoutHandler: (event: FocusEvent) => void;

  constructor() {
    this.focusoutHandler = this.handleFocusOut.bind(this);
  }

  ngOnInit(): void {
    this.el.nativeElement.addEventListener('focusout', this.focusoutHandler, true);
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('focusout', this.focusoutHandler, true);
  }

  private handleFocusOut(event: FocusEvent): void {
    event.stopPropagation();
  }
}
